/**
 * TurnTransition Component - Screen blocker for pass-and-play mode
 */

import React from 'react';

function TurnTransition({
  currentPlayer,
  isIntro = false,
  onReady,
  playerDisplayName,
}) {
  const playerClass = currentPlayer === 'X' 
    ? 'stt-turn-transition__player--x' 
    : 'stt-turn-transition__player--o';
  const label = playerDisplayName || `Player ${currentPlayer}`;

  return (
    <div className="stt-turn-transition" role="dialog" aria-modal="true">
      <div className="stt-turn-transition__content">
        <h2 className="stt-turn-transition__title">
          {isIntro ? 'Pass & Play' : 'Pass the device to'}
        </h2>
        <div className={`stt-turn-transition__player ${playerClass}`}>
          {label}
          {isIntro ? ' goes first' : ''}
        </div>
        <p className="stt-turn-transition__instruction">
          {isIntro
            ? 'Share this device. Tap when the first player is ready.'
            : 'Tap when ready to take your turn'}
        </p>
        <button 
          className="stt-btn stt-btn--primary"
          onClick={onReady}
          autoFocus
        >
          I'm Ready
        </button>
      </div>
    </div>
  );
}

export default TurnTransition;
